import { jwtDecode } from "jwt-decode";

import { Session, Token } from "@/shared/lib/types/auth";

export function getSession(): Session | null {
  const accessToken = localStorage.getItem("AppContext");

  if (!accessToken) {
    return null;
  }

  let data: Token;
  try {
    data = jwtDecode<Token>(accessToken);
  } catch {
    localStorage.removeItem("AppContext");
    return null;
  }

  if (!data) {
    return null;
  }

  if (data.exp * 1000 < Date.now()) {
    localStorage.removeItem("AppContext");
    return null;
  }

  return {
    id: data.sub,
    token: data,
    rawToken: accessToken,
  };
}

export function setSession(accessToken: string): void {
  localStorage.setItem("AppContext", accessToken);
}

export function deleteSession(): void {
  localStorage.removeItem("AppContext");
}
